import {ControllerParams} from '@wix/yoshi-flow-editor';
import {IWidgetControllerConfig} from '@wix/native-components-infra';
import {BaseController, EcomPlatformViewerScriptContext} from '@wix/wixstores-client-storefront-sdk';
import {IAddToCartOptions} from '../../../types/product';
import {FedopsInteraction, SPECS} from '../../../constants';
import {IAddToCartItem, STORES_APP_DEF_ID} from '@wix/wixstores-client-core';
import {Scope} from '@wix/app-settings-client/dist/src/domain';
import {CartIconStore} from '../../../domain/stores/CartIconStore';
import {ICartIconStyleParams} from '../../../types/app-types';
import {ecomTestBiSrc130Evid160} from '@wix/bi-logger-ecom-platform-data/v2';

export class CartIconController extends BaseController {
  protected cartIconStore!: CartIconStore;
  protected controllerConfig!: IWidgetControllerConfig;
  protected currentCartService!: EcomPlatformViewerScriptContext['currentCartService'];
  constructor(controllerParams: ControllerParams) {
    super(controllerParams);
    this.flowAPI.fedops.interactionStarted(FedopsInteraction.CART_ICON_LOADED);
    this.setStoresAndCreateCartExports(controllerParams);
    this.controllerConfig = controllerParams.controllerConfig;

    /* istanbul ignore else */
    if (this.siteStore.experiments.enabled(SPECS.CheckViewerCurrency)) {
      try {
        void this.siteStore.webBiLogger.report(
          ecomTestBiSrc130Evid160({
            type: 'ViewerCurrency',
            data: JSON.stringify({
              currency: this.flowAPI.controllerConfig.wixCodeApi.site.currency,
              regionalSettings: this.flowAPI.controllerConfig.wixCodeApi.site.regionalSettings,
              language: this.flowAPI.controllerConfig.wixCodeApi.site.language,
            }),
          })
        );
      } catch {
        //
      }
    }
  }

  private setStoresAndCreateCartExports({controllerConfig, flowAPI, appData}: ControllerParams) {
    this.currentCartService = appData?.context.currentCartService;
    this.cartIconStore = new CartIconStore(
      this.siteStore,
      controllerConfig.config,
      controllerConfig.setProps,
      flowAPI.reportError,
      flowAPI.translations,
      flowAPI.fedops,
      flowAPI.panoramaClient,
      controllerConfig.wixCodeApi,
      this.currentCartService
    );
    if (this.siteStore.isMobile() && controllerConfig.config.publicData?.APP?.DONT_SHOW_SIDE_CART_ON_MOBILE) {
      this.siteStore.dontShowSideCartOnMobile = true;
    }
  }

  public readonly load = async () => {
    await this.cartIconStore.init();
  };

  public readonly init = async (): Promise<void> => {
    await this.load();
  };

  /* istanbul ignore next: todo: missing test */
  public onStyleUpdate = (newStyleParams: ICartIconStyleParams) => {
    this.cartIconStore.updateStyleParams(newStyleParams);
  };

  /* istanbul ignore next: todo: missing test */
  public readonly onAppSettingsUpdate = (updates: {[key: string]: any}) => {
    if (updates.scope === Scope.COMPONENT && updates.source === 'app-settings') {
      this.cartIconStore.updateAppSettings(updates.payload);
    } else if (updates.details) {
      this.cartIconStore.updateAppSettings({main: updates.details});
    }
  };

  /* istanbul ignore next: todo: missing test */
  public readonly onBeforeUnLoad = () => {
    this.cartIconStore.unSubscribeAll();
  };

  public readonly exports = () => {
    return {
      addToCart: async (productId: string, quantity: number = 1, options: IAddToCartOptions = {}): Promise<boolean> => {
        await this.cartIconStore.executeWithFedops(FedopsInteraction.ADD_TO_CART, async () => {
          const storesAPI = await this.flowAPI.controllerConfig.wixCodeApi.site.getPublicAPI(STORES_APP_DEF_ID);
          return storesAPI.cart.addToCart(productId, quantity, options);
        });
        return true;
      },
      addProductsToCart: async (cartItems: IAddToCartItem[]): Promise<boolean> => {
        await this.cartIconStore.executeWithFedops(FedopsInteraction.ADD_ITEMS_TO_CART, async () => {
          const storesAPI = await this.flowAPI.controllerConfig.wixCodeApi.site.getPublicAPI(STORES_APP_DEF_ID);
          return storesAPI.cart.addProducts(cartItems);
        });
        return true;
      },
    };
  };

  public getFreeTexts(): string[] {
    return [];
  }
}
